import { StoreState } from '../types';

import { MessagesState } from './types';

export const getMessagesState = (state: StoreState): MessagesState =>
  state.messages;
